/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PreviousMonthAction/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import Tysiav2DoubleArrowLeft from 'DesignSystem/Svgs/Tysiav2DoubleArrowLeft/index'



/** @type {import('Simple/types.js').View} */
export default function PreviousMonthAction({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/Topbar/UpperSection/DateSelector/PreviousMonthAction"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 borderBottomRightRadius={0}
 borderTopRightRadius={0}
 onClick={onClick}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2DoubleArrowLeft
{...childProps}
  viewPath={`${viewPath}/Tysiav2DoubleArrowLeft`}
 width={10}
 height={10}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
{children}
</React.Fragment>)
}